export const showRejectExhibition = (state, flag) => {
	state.showRejectExhibition = flag
}

export const showDeletePayment = (state, flag) => {
	state.showDeletePayment = flag
}